import { render, staticRenderFns } from "./AddLiteratureModal.vue?vue&type=template&id=02827d49&"
import script from "./AddLiteratureModal.vue?vue&type=script&lang=js&"
export * from "./AddLiteratureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports